import { createStructuredSelector } from 'reselect';

const blacklistStore = state => state && state.blacklist;

const blacklistSelector = createStructuredSelector({
  blacklist: blacklistStore
});

export { blacklistSelector };
